import { InsuranceDetails } from 'Api/insurance';
import {
  CwpCoverage,
  StatusCwp,
} from 'Api/insurance/types/insurance.types.cwp';
import { AgreementCode } from 'Constants/agreementCodes.constants';
import { isDefined } from './type.utils';

export const getPriceFromCwp = (
  data: InsuranceDetails,
): {
  monthlyPriceToday: number;
  monthlyPriceAfterUpcomingChange?: number;
  monthlyPriceAfterLastChange?: number;
  yearlyPriceToday: number;
  yearlyPriceAfterUpcomingChange?: number;
  yearlyPriceAfterLastChange?: number;
} => {
  const { detailsCwp } = data;
  return {
    monthlyPriceToday: detailsCwp.price.today.monthlyPrice,
    monthlyPriceAfterUpcomingChange: isDefined(
      detailsCwp.price.afterUpcomingChange,
    )
      ? detailsCwp.price.afterUpcomingChange.monthlyPrice
      : undefined,
    monthlyPriceAfterLastChange: isDefined(detailsCwp.price.afterLastChange)
      ? detailsCwp.price.afterLastChange.monthlyPrice
      : undefined,
    yearlyPriceToday: detailsCwp.price.today.yearlyPrice,
    yearlyPriceAfterUpcomingChange: isDefined(
      detailsCwp.price.afterUpcomingChange,
    )
      ? detailsCwp.price.afterUpcomingChange.yearlyPrice
      : undefined,
    yearlyPriceAfterLastChange: isDefined(detailsCwp.price.afterLastChange)
      ? detailsCwp.price.afterLastChange.yearlyPrice
      : undefined,
  };
};

export const getAgreementCodeFromCwp = (
  data: InsuranceDetails,
): AgreementCode => data.detailsCwp.agreementCode;

export const getPolicyNumberFromCwp = (data: InsuranceDetails): string =>
  data.detailsCwp.policyNumber;

export const getChecksFromCwp = (
  data: InsuranceDetails,
): { isInRenewal: boolean; isCancelable: boolean } => {
  const { detailsCwp } = data;
  return {
    isInRenewal: detailsCwp.isInRenewal,
    isCancelable: detailsCwp.isCancelable,
  };
};

export const getDatesFromCwp = (
  insurance: InsuranceDetails,
): {
  renewalDate: string;
  originalIssueDate: string;
  upcomingChangeDate?: string;
  lastChangeDate?: string;
  cancellationDate?: string;
} => {
  const { detailsCwp } = insurance;
  return {
    renewalDate: detailsCwp.dates.renewalDateCwp,
    originalIssueDate: detailsCwp.dates.originalIssueDate,
    upcomingChangeDate: detailsCwp.dates.upcomingChangeDate ?? undefined,
    lastChangeDate: detailsCwp.dates.lastChangeDate ?? undefined,
    cancellationDate: detailsCwp.dates.cancellationDate ?? undefined,
  };
};

export const getConditionCodeFromCwp = (
  data: InsuranceDetails,
): {
  conditionCodeAfterChange?: string;
  conditionCodeToday: string;
} => {
  const {
    detailsCwp: { conditionCode },
  } = data;

  let afterChange;

  if (isDefined(conditionCode.afterLastChange)) {
    afterChange = conditionCode.afterLastChange;
  } else if (isDefined(conditionCode.afterUpcomingChange)) {
    afterChange = conditionCode.afterUpcomingChange;
  }

  return {
    conditionCodeToday: conditionCode.today,
    conditionCodeAfterChange: afterChange,
  };
};

export const isUnderActivation = (insurance: InsuranceDetails): boolean =>
  insurance.detailsCwp.status.today === StatusCwp.UNDER_ACTIVATION;

export const isUnderCancellation = (insurance: InsuranceDetails): boolean =>
  insurance.detailsCwp.status.today === StatusCwp.CANCELLED;

export const getCoveragesFromCwp = (
  insurance: InsuranceDetails,
): CwpCoverage[] => {
  const { detailsCwp } = insurance;
  return detailsCwp.coverages.today;
};
